import { Plugin } from '@ckeditor/ckeditor5-core';
import { UIModel as Model } from '@ckeditor/ckeditor5-ui';
import { Collection } from '@ckeditor/ckeditor5-utils';
import { addListToDropdown, createDropdown, } from '@ckeditor/ckeditor5-ui';
import widgetIcon from './widget.svg';
class ToolbarMenuEditing extends Plugin {
    init() { }
}
class ToolbarMenuUI extends Plugin {
    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add('toolbarMenu', (locale) => {
            const dropdownView = createDropdown(locale);
            dropdownView.buttonView.set({
                label: 'Insert widget',
                icon: widgetIcon,
                tooltip: true,
            });
            // The collection of the list items.
            const items = new Collection();
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Embed code',
                    commandName: 'insertEmbedCode',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Callout',
                    commandName: 'insertCallout',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Statistical Insight',
                    commandName: 'insertStatInsight',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Expert Tip',
                    commandName: 'insertExpertTip',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Resources',
                    commandName: 'insertResources',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: "Do / Don't",
                    commandName: 'insertComparison',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Copyable',
                    commandName: 'insertCopyable',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Raw HTML',
                    commandName: 'insertRawHtml',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Template slider',
                    commandName: 'insertTemplateSlider',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Compare resumes',
                    commandName: 'insertCompareResumes',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Related article',
                    commandName: 'insertRelatedArticle',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Related example',
                    commandName: 'insertRelatedExample',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Skills',
                    commandName: 'insertSkills',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Salaries',
                    commandName: 'insertSalaries',
                }),
            });
            items.add({
                type: 'button',
                model: new Model({
                    withText: true,
                    label: 'Resume Examples',
                    commandName: 'insertResumeExample',
                }),
            });
            addListToDropdown(dropdownView, items);
            this.listenTo(dropdownView, 'execute', (evt) => {
                editor.execute(evt.source.commandName);
            });
            return dropdownView;
        });
    }
}
export default class ToolbarMenu extends Plugin {
    static get requires() {
        return [ToolbarMenuEditing, ToolbarMenuUI];
    }
}
